import React, { useEffect, useState } from 'react';
import DateRangeSelector from '../../../../Ui-Elemnent/DateRange';
import CalenderSelctor from '../../../../Ui-Elemnent/Calender';
import SocietiesServiced from './SocietiesServiced';
import format from 'date-fns/format';
import BarChartComponent from './BarChartComponent';
import SocietySegregationChart from './SocietySegregationChart';

const SocietyDashboard = ({ city }: { city: string }) => {
  const [selectedTab, setSelectedTab] = useState('Societies serviced');
  const [calendar, setCalendar] = useState<any>(new Date());
  const [selectedDate, setSelectedDate] = useState(format(new Date(), 'yyyy-MM-dd'));
  const [showExtraInfo, setShowExtraInfo] = useState('');

  // Date Range states
  const [dayDiff, setDayDiff] = useState<any>();
  const today = new Date();
  const [toDate, setToDate] = useState<string>(format(new Date(), 'yyyy-MM-dd'));
  const [fromDate, setFromDate] = useState<string>(format(new Date(), 'yyyy-MM-dd'));
  const [range, setRange] = useState<any[]>([
    {
      endDate: new Date(),
      startDate: today.setDate(today.getDate() - 6),
      key: 'selection',
    },
  ]);

  // TSP Count states
  const [totalTspCount, setTotalTspCount] = useState<number>(0);
  const [cleanTspCount, setCleanTspCount] = useState<number>(0);
  const [totalTspCountInWard, setTotalTspCountInWard] = useState<number>(0);
  const [cleanTspCountInWard, setCleanTspCountInWard] = useState<number>(0);

  // Effect to handle date range changes
  useEffect(() => {
    setToDate(format(range[0].endDate, 'yyyy-MM-dd'));
    setFromDate(format(range[0].startDate, 'yyyy-MM-dd'));
    setDayDiff((range[0].endDate - range[0].startDate) / 86400000);
  }, [range]);

  // Effect to handle calendar changes
  useEffect(() => {
    setSelectedDate(format(calendar, 'yyyy-MM-dd'));
  }, [calendar]);

  const TabName = [
    {
      tabName: 'Societies serviced',
      numerator: 8,
      denominator: 13,
      extraInfo:
        'Shows the number of bins where the collection happened over the selected timeline. When selected timeline is more than a day, it will be averaged.',
    },
    {
      tabName: 'Quantity collected',
      numerator: 14,
      denominator: 14,
      extraInfo: 'Shows the number of bin cleaned up for a particular ward on the selected date.',
    },
    {
      tabName: 'Societies segregating',
      numerator: 10,
      denominator: 13,
      extraInfo: 'Shows the number of bin cleaned up for a particular ward on the selected date.',
    },
  ];

  const HandleOnMouseEnter = (tabName: string) => {
    setShowExtraInfo(tabName);
  };

  const HandleOnMouseLeave = () => {
    setShowExtraInfo('');
  };

  return (
    <div className="w-full ml-2 mt-8 h-1/3">
      <div className="flex justify-end mr-4">
        {selectedTab === 'Ward Wise Bin Clean-Up' ? (
          <CalenderSelctor calendar={calendar} setCalendar={setCalendar} />
        ) : (
          <DateRangeSelector range={range} setRange={setRange} />
        )}
      </div>
      <div className="border-2 border-t-0 bg-white">
        <div className="flex justify-between">
          {TabName.map((item, index) => (
            <div
              key={index}
              className={`h-12 border text-white w-1/2 cursor-pointer hover:bg-lightBlue hover:text-recity py-2 border border-black ${
                selectedTab === item.tabName
                  ? 'bg-lightBlue text-recity'
                  : 'text-white bg-recity'
              }`}
              onClick={() => setSelectedTab(item.tabName)}
              onMouseEnter={() => HandleOnMouseEnter(item.tabName)}
              onMouseLeave={HandleOnMouseLeave}
            >
              <h1 className="text-2xl font-medium text-center">
                {item.tabName}{' '}
                {item.tabName === 'Quantity collected' ? (
                  `(${!Number.isNaN(item.numerator) ? Math.floor(item.numerator).toString() : 0}kg)`
                ) : (
                  `(${!Number.isNaN(item.numerator) ? Math.floor(item.numerator).toString() : 0}/${
                    Math.floor(item.denominator).toString()
                  })`
                )}
              </h1>
              <div
                className={`relative text-sm rounded-lg bg-black text-white items-end mx-auto mt-2 py-4 ${
                  showExtraInfo !== item.tabName ? 'hidden' : ''
                }`}
              >
                {item.extraInfo}
              </div>
            </div>
          ))}
        </div>

        {/* Render the content for selected tab */}
        <div style={{ width: "300px", margin: "0 auto" }}>
          {selectedTab === 'Societies serviced' ? (
            <SocietiesServiced
              city={city}
              fromDate={fromDate}
              toDate={toDate}
              setTotalTspCount={setTotalTspCount}
              setCleanTspCount={setCleanTspCount}
            />
          ) : (
            <div className="text-center py-4 text-lg font-medium text-gray-500"> </div>
          )}
        </div>

        {/* Render "Coming Soon" for unselected tabs */}
        <div>
          {selectedTab === 'Quantity collected' && (
            <div className="text-center py-4 text-lg font-medium text-gray-500">
              <h2>Waste Categories Chart</h2>
              <BarChartComponent />
            {/* <div className="text-center py-4 text-lg font-medium text-gray-500">Coming Soon</div> */}
            </div>
          )}
          {selectedTab === 'Societies segregating' && (
            <div style={{ width: "400px", margin: "0 auto" }}>
              <SocietySegregationChart />
              {/* Coming Soon */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SocietyDashboard;
